import React from "react";
import { useNavigate } from "react-router-dom";
import "./CSS/Banner.css";
import shuttle from "./bannericons/Shuttle.png";
import credit from "./bannericons/Credit.png";
import money from "./bannericons/Money.png";
import cs from "./bannericons/CS.png";
import ban1 from "./bannericons/ban1.jpg";
import ban2 from "./bannericons/ban2.jpg";
import ban3 from "./bannericons/ban3.jpg";

const Banner = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: shuttle,
      title: "Free Delivery",
      description: "From Rs99.00",
    },
    {
      icon: money,
      title: "Money Guarantee",
      description: "7 days back",
    },
    {
      icon: credit,
      title: "Payment Method",
      description: "Secure payment",
    },
    {
      icon: cs,
      title: "Support 24/7",
      description: "Online 24 hours",
    },
  ];

  const bannerImages = [ban1, ban2, ban3];

  const handleBannerClick = async () => {
    try {
      const response = await fetch("https://dehleze.shop/product-create/");
      const data = await response.json();
      console.log("Fetched Banner Products:", data); // 👈 Logs data on click

      localStorage.setItem("selected_products", JSON.stringify(data));
      navigate("/search-product"); // 👈 Redirect to ProductsPage
    } catch (error) {
      console.error("Error fetching banner products:", error);
    }
  };

  return (
    <>
      <div className="pt-4"></div>
      <div className="cate-heading" style={{ marginBottom: "3rem" }}>
        <h2>Discount Offers</h2>
      </div>
      <div className="banner-container">
        {bannerImages.map((image, index) => (
          <div
            key={index}
            className="banner-item"
            onClick={handleBannerClick}
            style={{ cursor: "pointer" }}
          >
            <img
              src={image}
              alt={`Banner ${index + 1}`}
              className="banner-img"
            />
          </div>
        ))}
      </div>
      <div className="p-3">
        <div className="features-container">
          {features.map((feature, index) => (
            <div className="feature-item" key={index}>
              <img src={feature.icon} alt="icon" />
              <div className="feature-content">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Banner;
